module.exports = __webpack_public_path__ + "files/e0cffbe8fea07b3091a508d34102307e.png";